// Mandrain language file
export const mand_texts = [
	"Hello, ",
	"This is a test!",
	"OK",
	"Cancel",
	"English",
	"မြန်မာ",
	"普通话",
	"Kayin",
	"Rakhine",
	"Chin",
	"တႆး",
	"Jinghpaw",
	"无法连接到服务器。请检查您的网络连接并重试。如果问题仍然存在,请联系我们的支持。",
	"家",
	"探索",
	"警报",
	"居住",
	"消息",
	"工作室",
	"我",
	"好的",
	"错误",
	"删除",
	"(向左滑动删除)",
	"用谷歌登录",
	"用苹果登录",
	"使用电子邮件登录",
	"电子邮件",
	"密码",
	"忘记密码",
	"登录",
	"登记",
	"您确定要退出吗？",
	"电子邮件： ",
	"编辑你的名字",
	"上传头像",
	"选择语言",
	"登出",
	"加载中...",
	"上传内容",
	"选择你的内容",
	"粘贴您的视频",
	"下一个",
	"告诉我怎么做？",
	"YouTube 视频代码:",
	"视频标题：",
	"描述：",
	"类别：",
	"标签（可选）：",
	"上传",
	"请添加有效的 YouTube 视频代码。请参阅 Show-me-how 了解如何查找 YouTube 视频代码。",
	"请在上传视频前添加视频标题。",
	"关闭 UI 并丢失所有数据？",
	"取消上传",
	"新频道",
	"频道名称：",
	"描述：",
	"类别：",
	"创建频道",
	"在上传视频之前,您必须为它们创建一个频道。一个用户可以有多个频道来对不同类型的视频进行分组。",
	"编辑频道",
	"节省",
	"您的频道：",
	"频道列表：",
	"你的视频：",
	"描述",
	"编辑频道",
	"删除频道",
	"您确定要删除此频道及其所有视频吗？此操作无法撤消。",
	"上传频道图片",
	"编辑频道",
	"管理所有频道",
	"无效的 YouTube 视频代码。请检查 Show-me-how 以正确复制视频代码。",
	"渠道：",
	"您的内容上传成功！",
	"您在此频道中没有任何视频。",
	"加一个",
	"输入信息...",
	"请输入电邮地址...",
	"上传图片",
	"寄钱",
	"装载更多",
	"删除消息",
	"阻止用户",
	"黑名单",
	"删除聊天消息？",
	"删除此聊天中的所有消息？无法撤消。",
	"阻止用户？",
	"您确定要屏蔽此用户吗？",
	"网络离线...",
	"我们该怎样帮助你？",
	"让我们知道您的问题,我们的支持团队会尽快与您联系！！",
	"通知",
	"您没有新的通知。",
	"没有被阻止的用户",
	"如果您阻止某人,他们将显示在此处。",
	"黑名单",
	"取消阻止用户",
	"您确定要从您的阻止列表中删除该用户吗？",
	"您无法发送消息...",
	"交易日期",
	"我需要更多的时间",
	"消息",
	"页",
	"请求",
	"搜索...",
	"没有消息",
	"你暂时没有任何消息。",
	"创建新内容...",
	"创建帖子",
	"上传视频",
	"添加图像",
	"创建一个帖子",
	"能见度：",
	"你钱包里的美元:",
	"可用 LIKES (N-Tokens):",
	"购买喜欢（N-Tokens）",
	"你没有 N-Wallet",
	"安装并设置 N-Wallet 应用程序以更好地管理您的钱包帐户。",
	"获取 N 钱包",
	"管理你的钱",
	"N-Wallet 让您可以更好地管理您的所有资金和代币。",
	"打开 N 钱包",
	"薄荷喜欢玩游戏！",
	"您可以通过玩我们的游戏获得免费的 LIKES (N-token)。",
	"玩游戏",
	"所有游戏",
	"亮点",
	"新游戏",
	"游戏",
	"直接下载APK",
	"iOS 应用商店",
	"谷歌商店",
	"（适用于 Android 版本较低的手机）",
	"你的钱包",
	"注释",
	"第一个喜欢？先读这个！",
	"N-Social 中的 LIKES 与其他社交网络不同。您需要花费一个 N-Token 来点赞帖子。帖子的所有者将收到您的 LIKE 作为 N-Token,他们可以将其用于其他帖子或他们可以转换它。除非您的帐户中有 N-Token,否则您将无法点赞帖子。您可以通过玩我们的游戏或直接从商店购买来免费获得 N-Token。",
	"我明白了",
	"获得免费的 N 代币",
	"什么是超级喜欢？",
	"您可以根据需要多次喜欢帖子。本质上,您是在向帖子所有者发送 N-Tokens 作为感谢。Super LIKE 允许您发送 10 个 N-Tokens,而不是向所有其他人显示您是超级粉丝的一个帖子！！您可以通过玩我们的游戏或直接从商店购买来获得免费的 N-Token。",
	"您没有 N-Token 来发送 LIKE。购买 N-Token 或玩我们的游戏以获得免费代币！！",
	"成为第一个喜欢这个...",
	"写个评论...",
	"成为第一个评论...",
	"请先安装 N-Wallet 并进行设置,然后才能购买或出售 N-Tokens。",
	"X 率：",
	"喜欢（N-令牌）：",
	"购买喜欢",
	"删除",
	"您没有足够的美元购买 LIKES (N-Tokens)。",
	"你钱包里的美元:",
	"美元价格：",
	"汇率：",
	"LIKES (N-Tokens) 你将收到：",
	"您的钱包里还剩美元：",
	"购买喜欢",
	"确认购买",
	"清除",
	"确认",
	"输入您的密码：",
	"总美元：",
	"喜欢（N-令牌）：",
	"后退",
	"购买成功",
	"看法",
	"喜欢价格",
	"(N-Token 对美元汇率)",
	"更新： ",
	"购买喜欢",
	"搜索...",
	"信息",
	"跟随",
	"取消关注",
	"朋友",
	"跟随",
	"分享帖子",
	"向管理员报告",
	"阻止用户",
	"追随者",
	"编辑个人资料",
	"关注此用户",
	"关注用户",
	"取消关注用户",
	"删除帖子",
	"删除帖子？",
	"您确定要删除此帖子并丢失所有评论和点赞吗？此操作无法撤消。",
	"注销？",
	"追随者：",
	"请详细解释为什么这篇文章不应该出现在 N-Social 上。你包含的信息越多,管理员就越能决定要采取什么行动。如果你不这样做,你的报告将被忽略为报告提供足够的理由。感谢您花时间让 N-Social 社区保持活力和安全！",
	"举报理由",
	"您的报告已提交给我们的管理员。他们将检查您的报告并采取适当的措施。",
	"通知",
	"未读",
	"看到所有",
	"支持者：",
	"无效内容",
	"您要查找的内容不存在或已被删除。",
	"忘记密码？",
	"输入您的电子邮件以重置您的密码：",
	"重设密码",
	"创建您的帐户",
	"无效的电子邮件格式",
	"密码必须至少8个字符",
	"确认密码：",
	"您的密码和确认的密码不匹配",
	"推荐电子邮件：",
	"登记",
	"（我们不会分享您的个人信息）",
	"您的推荐人 ID（可选）",
	"确认电子邮件",
	"确认邮件已发送。请点击邮件中的链接",
	"电子邮件确认",
	"重发电子邮件",
	"邮件确认成功！",
	"电子邮件已重新发送。请检查您的收件箱,包括垃圾邮件文件夹",
	"更换名字",
	"输入你的新名字：",
	"更换名字",
	"改变你的语言",
	"改变",
	"英语",
	"普通话",
	"缅甸",
	"邮政",
	"添加到帖子",
	"图片）",
	"Youtube 视频",
	"文章标题",
	"问卷",
	"隐藏",
	"粘贴 YouTube 视频",
	"帖子标题",
	"你在想什么...",
	"内容结​​束...",
	"喜欢解锁",
	"超级喜欢解锁",
	"喜欢解锁这篇文章",
	"超级喜欢解锁这篇文章",
	"在 N-Social 上关注人们以在此处查看他们的内容。前往探索以查看其他人发布的内容,如果您喜欢他们的内容,您可以关注他们在此处查看他们的帖子或给他们一两个赞！",
	"探索他人",
	"关注者/关注者",
	"照片库",
	"受欢迎的",
	"新闻媒体",
	"趋势",
	"最新的",
	"目前该类别没有内容。请稍后再查看或探索其他类别。",
	"Currently there is no content in this category. Check back later or explore other categories.",
	"Comment Likes/Dislikes",
	"Copy Text",
	"Delete Comment",
	"Delete Comment?",
	"Are you sure you want to delete this comment? This cannot be undone.",
	"Friends",
	"Followed",
	"Followers",
	"You have no friend yet",
	"Follow other people and when they followed you back, you will become friends. Friends can see each other private posts!",
	"You haven't follow anybody yet",
	"You can follow other people if you like their posts so you can see them everytime they post!",
	"You have no follower",
	"If other people follow you, they will be shown here!",
	"Reply To This",
	"ALL",
	"LIKES",
	"DISLIKES",
	"Replying to...",
	"Share My Profile",
	"New Update Available",
	"Update Information:",
	"Download From PlayStore",
	"Download From AppStore",
	"Direct Download",
	"App is in maintenance mode",
	"We Are Sorry!!",
	"Check Again",
];